import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";

import { useLeadSubmission } from "@/hooks/useLeadSubmission";
const PhoneForm = () => {
  const [mobile, setMobile] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const {
    submitLead,
    isSubmitting
  } = useLeadSubmission();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!mobile) {
      return;
    }

    // Fire GTM event for phone submission
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'cta_phone_submit'
      });
    }
    try {
      const success = await submitLead(mobile, 'phone_form');
      if (success) {
        setIsSubmitted(true);
        setIsChatOpen(true);
        // Open WhatsApp chat
        const whatsappMessage = `Hi! I submitted my phone number ${mobile}. I want to pick clothes on camera.`;
        window.open(`https://wa.me/4915754767196?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      // Even if there's an error with external services, show the chat
      setIsSubmitted(true);
      setIsChatOpen(true);
    }
  };
  const handleZoomClick = () => {
    // Fire GTM event for Zoom click
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'cta_zoom_click'
      });
    }

    // Open Zoom meeting
    window.open('https://us04web.zoom.us/j/4293507554?pwd=MyHMpmALzmbqRiVtl8YpMpP9ztV9Ea.1', '_blank');
  };
  return <section className="section-spacing" style={{
    backgroundColor: 'rgba(27, 33, 57, 0.95)'
  }}>
      <div className="container mx-auto px-6 md:px-8 lg:px-4">
        <div className="max-w-md mx-auto">
          
        </div>
      </div>
    </section>;
};
export default PhoneForm;